<template>
  <el-col :span="24">
    <div class="message" :class="typeClass">
      <p class="message--date">
        {{ $d(message.createdAt, 'long') }}
      </p>
      <p class="message--text">
        {{ message.message }}
      </p>
      <div v-if="message.imgs.length">
        <ImgCard
          v-for="img in message.imgs"
          :max-width="200"
          :key="img"
          :url="img" />
      </div>
    </div>
  </el-col>
</template>

<script>
import ImgCard from '@/utils/components/ImgCard.vue';

export default {
  name: 'message',
  components: {
    ImgCard,
  },
  props: {
    message: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    typeClass() {
      return this.message.iscontact ? 'is-contact' : 'is-user';
    },
  },
};
</script>

<style lang="scss" scoped>

.message {
  margin: 20px 0;
  &.is-user {
    text-align: right;
    .message--text {
      background-color: $--color-light-grey;
    }
  }
  &.is-contact {
    .message--text {
      background-color: $--color-tertiary;
      color: $--color-white;
    }
  }
  &--date {
    opacity: 0.65;
    margin: 0;
  }
  &--text {
    border-radius: 10px;
    max-width: 60%;
    padding: 10px;
    display: inline-block;
    margin: 0;
  }
}
</style>
